export default __webpack_public_path__ + "static/media/d1.3c4df5c5.png";